<template>
  <div class="table-wrapper">
    <div class="card data-table" >
      <table>
        <thead v-if="titleColumn1 != '' || titleColumn2 != ''">
          <tr :style="titleStyle" :class="{'header-no-border' : tableRows.length == 0}">
            <th :style="titleColumn1Style">{{titleColumn1}}</th>
            <th :style="titleColumn2Style">{{titleColumn2}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in tableRows" :style="itemStyle" v-if="row.contentColumn1 != '' || row.contentColumn2 != ''" :key="index">
            <td :style="contentColumn1Style" v-html="addLineBreak(row.contentColumn1)"></td>
            <td :style="contentColumn2Style" v-html="addLineBreak(row.contentColumn2)"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
}
from 'vuex'
import { HashCodeFromInt, ReplaceBackslashNtoBr } from '@/modules/helper/index'
export default {
  props: {
    titleColumn1: {
      type: String,
      default: ''
    },
    titleColumn2: {
      type: String,
      default: ''
    },
    titleColumnFontFace: {
      type: String,
      default: 'inherit'
    },
    tableRows: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapGetters([
      'DesignSettings'
    ]),
    titleColumn1Style() {
      return {
        'text-align': 'left',
        'width': '66%'
      }
    },
    titleColumn2Style() {
      return {
        'text-align': 'right',
        'width': '34%'
      }
    },
    contentColumn1Style() {
      return {
        'text-align': 'left',
        'width': '66%'
      }
    },
    contentColumn2Style() {
      return {
        'text-align': 'right',
        'width': '34%'
      }
    },
    titleStyle() {
      return {
        'color': HashCodeFromInt(this.DesignSettings.AppThemeSecondaryFontColor),
        'font-size': '15px',
        'font-family': this.titleColumnFontFace
      }
    },
    itemStyle() {
      return {
        'color': HashCodeFromInt(this.DesignSettings.AppThemeFontColor)
      }
    }
  },
  methods: {
    addLineBreak(value) {
      return ReplaceBackslashNtoBr(value)
    }
  }
}
</script>
<style scoped>
  .data-table table {
    width: 100%;
    border: none;
    padding: 0;
    margin: 0;
    border-collapse: collapse;
    border-radius: 7px;
  }
  .data-table thead th {
    padding: 15px 15px 15px 15px;
    font-weight: bold;
    height: 100%;
    position: unset;
  }
  .data-table td {
    padding: 10px 15px 10px 15px;
    height: 100%;
    position: unset;
  }
  .data-table thead .header-no-border {
    border-bottom: none!important;
  }
  .data-table tbody tr {
    border-top: 1px solid rgba(255, 255, 255, 0.53);
  }
  .table-wrapper{
    padding: 5px 5px;
  }
  .card.data-table {
    position: inherit!important;
    border-radius: 8px!important;
  }
  .data-table tbody tr:first-child {
    border-top: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Table.vue